<!--<style>-->
<!--.body{-->
<!--    background: #ececed;-->
<!--    color: #a1aed4;-->
<!--    font-size: 14px;-->
<!--    margin: 0;-->
<!--    overflow-anchor: none;-->
<!--    font-weight: 700 !important;-->
<!--    font-family: Roboto Condensed, sans-serif;-->
<!--    overflow-x: hidden;-->
<!--    scroll-behavior: smooth;-->
<!--}-->
<!--.odd-btn{-->
<!--    height: 44px;-->
<!--    border-radius: 4px;-->
<!--}-->
<!--.mbtn{-->
<!--      height: 44px;-->
<!--    border-radius: 4px;-->
<!--}-->
<!--.dropdown-toggle.cricket.show {-->
<!--    background: #f8bd23;-->
<!--}-->
<!--.dropdown-toggle.cricket.show {-->
<!--    background: #f8bd23;-->
<!--}-->
<!--.dropdown-toggle.cricket.show {-->
<!--    background: #f8bd23;-->
<!--}-->
<!--.li{-->
    
<!--    font-family: Roboto Condensed, sans-serif;-->
<!--    font-size: 14px;-->
<!--    font-weight: 700;-->
<!--}-->
<!--</style>-->
<!--<div>-->
<!--  <div class="mt-2 text-center">-->
<!--    <img-->
<!--      src="assets/images/100x.png"-->
<!--      style="width: 95px; height: 35px"-->
<!--    />-->
<!--    <span-->
<!--      (click)="onToggleSidenav()"-->
<!--      style="color: #aaafb5; float: right; font-size: 40px; margin-right: 20px"-->
<!--      class="material-symbols-outlined"-->
<!--    >-->
<!--      menu-->
<!--    </span>-->
<!--  </div>-->
  <!-- <div class="profile text-white">
<!--    <div class="m-3 text-white">-->
<!--            <span style="font-size:50px" class="material-symbols-outlined text-white">-->
<!--            account_circle-->
<!--            </span>-->
<!--      <br>{{username|uppercase}}-->
<!--    </div>-->
<!--    <div class="m-3" (click)="logout()">-->
<!--      <a><span class="material-symbols-outlined text-danger">logout</span></a>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="row mt-5">-->
<!--    <div class="cardv">-->
<!--      <span class="material-symbols-outlined">account_balance_wallet</span>-->
<!--      <p class="mb-0">Balance</p>-->
<!--      <p *ngIf="exposure.length>0">{{balance+exposure[0].exp_amount| number : '.2-2'}}</p>-->
<!--    </div> -->
  <!--    <div class="cardv">-->
  <!--      <span class="material-symbols-outlined">casino</span>-->
  <!--      <p class="mb-0">Casino</p>-->
  <!--      <p>0</p>-->
  <!--    </div>-->
  <!-- <div class="cardv bg-warning text-dark">
<!--      <span class="material-symbols-outlined">exposure</span>-->
<!--      <p class="mb-0">Exposure</p>-->
<!--      <p *ngIf="exposure.length>0">{{0-exposure[0].exp_amount| number : '.2-2'}}</p>-->
<!--    </div>-->
<!--  </div> -->
<!--  <div class="mt-2">-->
      
<!--    <h5 class="side-heading pl-2" style="display:none;">All Sport</h5>-->
<!--    <nav class="navbar navbar-expand-lg navbar-bg">-->
<!--      <ul class="navbar-nav w-100">-->
        <!-- <li
<!--          class="list-group-item bg-transparent text-dark"-->
<!--          (click)="onToggleSidenav()"-->
<!--        >-->
<!--          <i class="menu-icons mr-7 d-icon icon-40"></i>-->
<!--          <span>Politics (0)</span>-->
<!--        </li> -->
        <!-- <li
<!--          class="list-group-item bg-transparent text-dark"-->
<!--          (click)="onToggleSidenav()"-->
<!--          routerLinkActive="active"-->
<!--          routerLink="/dashboard/home"-->
<!--        >-->
<!--          <img class="menu-icons mr-7" src="assets/icons/menu-inplay.png" />-->
<!--          <span>In-play</span>-->
<!--        </li> -->

<!--        <li class="lnav-item dropdown bg-transparent text-dark">-->
<!--          <a-->
<!--            class="nav-link dropdown-toggle cricket"-->
<!--            href="#"-->
<!--            role="button"-->
<!--            data-bs-toggle="dropdown"-->
<!--            aria-expanded="false"-->
<!--          >-->
            <!-- <img class="menu-icons" src="assets/icons/menu-cricket.png" /> -->
<!--            <span style="background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png); background-position: 0 -326px; -->
<!--    background-repeat: no-repeat;-->
<!--    background-size: 28px auto;-->
<!--    display: inline-block;-->
<!--    height: 24px;-->
<!--    margin-right: 5px;-->
<!--    overflow: hidden;-->
<!--    vertical-align: bottom;-->
<!--    width: 28px;"></span>-->
<!--            <span>Cricket ({{ total_competitions }})</span>-->
<!--          </a>-->

<!--          <ul class="submenu dropdown-menu">-->
<!--            <li-->
<!--              *ngFor="let competition of competitions"-->
<!--              class="lnav-item dropdown bg-transparent text-dark"-->
<!--              routerLinkActive="active"-->
<!--            >-->
<!--              <a-->
<!--                class="nav-link dropdown-toggle dropdown-link"-->
<!--                href="#"-->
<!--                role="button"-->
<!--                data-bs-toggle="dropdown"-->
<!--                aria-expanded="false"-->
<!--              >-->
<!--                <span (click)="$event.stopPropagation()"-->
<!--                  >{{ competition.competition_name }} ({{-->
<!--                    competition.total-->
<!--                  }})</span-->
<!--                >-->
<!--              </a>-->
<!--              <ul class="submenu dropdown-menu subsub-menu">-->
<!--                <li *ngFor="let event of competition.events">-->
<!--                  <a-->
<!--                    class="dropdown-item"-->
<!--                    (click)="navigateToEventDetails(event, 'cricket')"-->
<!--                    >{{ event.event_name }}</a-->
<!--                  >-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </li>-->

<!--        <li class="lnav-item dropdown bg-transparent text-dark">-->
<!--          <a-->
<!--            class="nav-link dropdown-toggle football"-->
<!--            href="#"-->
<!--            role="button"-->
<!--            data-bs-toggle="dropdown"-->
<!--            aria-expanded="false"-->
<!--          >-->
            <!-- <img class="menu-icons" src="assets/icons/menu-football.png" /> -->
<!--              <span style="background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png); background-position: 0 -1026px; -->
<!--    background-repeat: no-repeat;-->
<!--    background-size: 28px auto;-->
<!--    display: inline-block;-->
<!--    height: 24px;-->
<!--    margin-right: 5px;-->
<!--    overflow: hidden;-->
<!--    vertical-align: bottom;-->
<!--    width: 28px;"></span>-->
<!--            <span>Football ({{ soccer_total_competitions }})</span>-->
<!--          </a>-->

<!--          <ul class="submenu dropdown-menu">-->
<!--            <li-->
<!--              *ngFor="let competition of soccer_competitions"-->
<!--              class="lnav-item dropdown bg-transparent text-dark"-->
<!--              routerLinkActive="active"-->
<!--            >-->
<!--              <a-->
<!--                class="nav-link dropdown-toggle dropdown-link"-->
<!--                href="#"-->
<!--                role="button"-->
<!--                data-bs-toggle="dropdown"-->
<!--                aria-expanded="false"-->
<!--              >-->
<!--                <span (click)="$event.stopPropagation()"-->
<!--                  >{{ competition.competition_name }} ({{-->
<!--                    competition.total-->
<!--                  }})</span-->
<!--                >-->
<!--              </a>-->
<!--              <ul class="submenu dropdown-menu subsub-menu">-->
<!--                <li *ngFor="let event of competition.events">-->
<!--                  <a-->
<!--                    class="dropdown-item"-->
<!--                    (click)="navigateToEventDetails(event, 'football')"-->
<!--                    >{{ event.event_name }}</a-->
<!--                  >-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </li>-->

<!--        <li class="lnav-item dropdown bg-transparent text-dark">-->
<!--          <a-->
<!--            class="nav-link dropdown-toggle tennis"-->
<!--            href="#"-->
<!--            role="button"-->
<!--            data-bs-toggle="dropdown"-->
<!--            aria-expanded="false"-->
<!--          >-->
            <!-- <img class="menu-icons" src="assets/icons/menu-tennis.png" /> -->
<!--            <span style="background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png); background-position: 0 -1096px; -->
<!--    background-repeat: no-repeat;-->
<!--    background-size: 28px auto;-->
<!--    display: inline-block;-->
<!--    height: 24px;-->
<!--    margin-right: 5px;-->
<!--    overflow: hidden;-->
<!--    vertical-align: bottom;-->
<!--    width: 28px;"></span>-->
<!--            <span>Tennis ({{ tennis_total_competitions }})</span>-->
<!--          </a>-->

<!--          <ul class="submenu dropdown-menu">-->
<!--            <li-->
<!--              *ngFor="let competition of tennis_competitions"-->
<!--              class="lnav-item dropdown bg-transparent text-dark"-->
<!--              routerLinkActive="active"-->
<!--            >-->
<!--              <a-->
<!--                class="nav-link dropdown-toggle dropdown-link"-->
<!--                href="#"-->
<!--                role="button"-->
<!--                data-bs-toggle="dropdown"-->
<!--                aria-expanded="false"-->
<!--              >-->
<!--                <span (click)="$event.stopPropagation()"-->
<!--                  >{{ competition.competition_name }} ({{-->
<!--                    competition.total-->
<!--                  }})</span-->
<!--                >-->
<!--              </a>-->
<!--              <ul class="submenu dropdown-menu subsub-menu">-->
<!--                <li *ngFor="let event of competition.events">-->
<!--                  <a-->
<!--                    class="dropdown-item"-->
<!--                    (click)="navigateToEventDetails(event, 'tennis')"-->
<!--                    >{{ event.event_name }}</a-->
<!--                  >-->
<!--                </li>-->
<!--              </ul>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </nav>-->
<!--  </div>-->
  <!-- <div style="position: fixed; bottom: 0;" class="mt-5">
<!--    <ngb-carousel>-->
<!--      <ng-template *ngFor="let banner of banner_url" ngbSlide>-->
<!--        <div class="slide-container border-white">-->
<!--          <img style="width:100%" [src]="banner.path"-->
<!--              class='carouselImage'>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </ngb-carousel>-->
<!--  </div> -->
<!--</div>-->



<style>
.bet-table-header{
    border-bottom: 0px solid #c7c8ca;
    border-top: 0px solid #c7c8ca;
    padding: 0px 0;}
    
    .odd-box{
        border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    float: left;
    font-size: 14px;
    line-height: 13px !important;
    padding: 5px 0;
    width: 49% !important;
        margin-right: 0.5%;
    }
    .bet-table-row
    {padding: 2px 1px;}
    
   
    .bet-nation-game-name span {
        color: #000 !important;
    font-family: Roboto Condensed, sans-serif !important;
    font-weight: 700 !important;
            cursor: pointer;
    display: inline-block;
    font-weight: 700;
    line-height: 17px;
    max-width: 750px !important;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
}
    }
    
    .over-wrap {
    overflow: hidden;
    overflow-y: auto;
}


/* Show on desktop (768px and up) */
@media (min-width: 768px) {
  .goneonmobile {
    display: block;
      

  }
  .mbmb1oa{
      width:84%;
  }
}

</style>

<div style="display:flex;">
    
                    <div class="col-left col-left-login goneonmobile" style="width: 100%; background-color: #FFF;" id="sidebar"><div class="sub_path over-wrap">
                <ul class="list-unstyled components">
  <p style=" background-color: #072c50;
    color: #fff;     margin: 0;
    padding: 2px 7px;
    text-transform: capitalize;">Popular <i class="fa fa-close pt-1 icon-toggle-right mobile-menu float-right"></i></p>
<style>
element.style {
    text-transform: capitalize;
}
#sidebar ul li a {
    border-bottom: 1px solid #e8e8e8;
    color: #000;
}
#sidebar ul li a {
    align-items: center;
    display: flex
;
    padding: 8px 10px;
}
#sidebar ul li a, #sidebar ul p {
    font-family: Roboto Condensed, sans-serif;
    font-size: 14px;
    font-weight: 700;
}
a[data-toggle=collapse] {
    position: relative;
}
a:not([href]), a:not([href]):hover {
    color: inherit;
    text-decoration: none;
}
.dropdown-toggle {
    white-space: nowrap;
}
a, a:active, a:focus, a:hover {
    outline: none;
    text-decoration: none;
}
a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
a {
    background-color: transparent;
    color: #007bff;
}
#sidebar ul li a:hover {
    background-color: #f8bd23;
    color: #000;
}
.list-unstyled.components .sports-icon {
    background-position: 0 -900px;
    background-repeat: no-repeat;
    background-size: 28px auto;
    display: inline-block;
    height: 24px;
    margin-right: 5px;
    overflow: hidden;
    vertical-align: bottom;
    width: 28px;
    background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png);
}
#sidebar ul li dropdown-toggle:hover {
    background-color: #f8bd23;
}

.dropdown-toggle::after {
        display: block;
    font-size: 16px;
    position: absolute;
   
        left: 14%;

    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    
    #sidetree {
    background: #e1e4ef;
    font-size: 12px;
    padding: 2px 5px;
}
}
</style>
 

  <li>
    <a aria-expanded="true"><span class="sports-icon inplayside" style=" background-position: 0 -1527px;"></span> In-Play</a>
  </li>

  <li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1775px;"></span> IPL 2025</a>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon cricketside" style="background-position: 0 -326px;"></span> Cricket</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Indian Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Royal Challengers Bengaluru v Rajasthan Royals</span></li>
            <li class="treeview"><span class="treeviewnode">Kolkata Knight Riders v Punjab Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Chennai Super Kings v Sunrisers Hyderabad</span></li>
            <li class="treeview"><span class="treeviewnode">Mumbai Indians v Lucknow Super Giants</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Womens One Day Internationals</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Sri Lanka Women v India Women</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">International Twenty20 Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Canada v USA</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Pakistan Super League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Quetta Gladiators v Karachi Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Lahore Qalandars v Peshawar Zalmi</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Test Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Bangladesh v Zimbabwe</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon soccerside" style="background-position: 0 -1026px;"></span> Soccer</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Spanish La Liga</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Getafe v Real Madrid</span></li>
            <li class="treeview"><span class="treeviewnode">Alaves v Real Sociedad</span></li>
            <li class="treeview"><span class="treeviewnode">Leganes v Girona</span></li>
            <li class="treeview"><span class="treeviewnode">Osasuna v Sevilla</span></li>
            <li class="treeview"><span class="treeviewnode">Atletico Madrid v Rayo Vallecano</span></li>
            <li class="treeview"><span class="treeviewnode">Betis v Valladolid</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Dutch Eredivisie</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Az Alkmaar v NAC Breda</span></li>
            <li class="treeview"><span class="treeviewnode">FC Twente v PSV</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">English Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Arsenal v Crystal Palace</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>
 

<li>
    <a href="./dashboard/livecasino?vendorId=SPB"><span class="" style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px; background-position: 0 -1775px;"><img style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px;" class="ball-images-tab" src="https://images.staticcontent.io/casino/banner/images/aviator-icon.svg" alt=""></span> Aviator</a>
</li>

<li 
    >
  
   <a href="./dashboard/livecasino?vendorId=AWC"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      AE Sexy
    </a>
</li>
<li *ngFor="let vendor of vendors"
    >
  
   <a href="./dashboard/livecasino?vendorId={{ vendor.providerCode }}"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      {{ vendor.providerName }}
    </a>

   

  <!--<ul class="dropdown-menu" style="background-color: #edf0fa; border-radius: 5px; padding: 10px; min-width: 240px;">-->
  <!--  <li *ngFor="let category of categories" style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #ddd;">-->
      
  <!--    <a class="dropdown-item" href="javascript:void(0);" -->
  <!--       (click)="onSelectCategory(category); onVendorChange(vendor.providerCode)"-->
  <!--       style="text-decoration: none; color: #000; padding-left: 10px; border-left: 2px solid #007bff; flex-grow: 1;">-->
  <!--      {{ category }}-->
  <!--    </a>-->

  <!--    <span style="display: inline-block; background-color: #fff; border: 1px solid #ccc; padding: 0px 5px; font-weight: bold; font-size: 14px; margin-left: 10px;">+</span>-->
  <!--  </li>-->
  <!--</ul>-->
</li>



</ul>
</div>
</div>